<div class="navbar-default">
    <div class="navbar-header">
        <div class="header-logo">
            <img *ngIf="!schoolClinic && description" src="/assets/images/horizontal_logo_lg.png"/>
            <img *ngIf="schoolClinic && description" src="/assets/images/horizontal_logo_lg_school.png"/>
        </div>
        <div
            class="header-title">
            <span>{{title}}</span>
            <span *ngIf="description" [fxHide.lt-md]="true"> - </span>
            <span class="header-description-container">
                <h2>{{description}}</h2>
            </span>
        </div>
    </div>
</div>
